var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Form',{attrs:{"page-title":"Edit Menu","buttonName":"Update","businessId":_vm.businessId,"branchId":_vm.branchId,"isInList":_vm.isInList,"model":_vm.model,"loading":_vm.loading},on:{"submit":_vm.submit}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }